import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { UserProvider } from '@fff-web/fff-utilities';
import App from './App';
import { getUserInfo } from './services';
import { loadTalkable } from './utils/loadTalkable';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

getUserInfo()
  .then((responseJson) => loadTalkable(responseJson))
  .catch((error) => {
    console.warn('Error loading Talkable', error);
    console.error(error);
    loadTalkable();
  });

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <UserProvider>
      <UniversalNavigationContextProvider>
        <App />
      </UniversalNavigationContextProvider>
    </UserProvider>
  </StrictMode>,
);
